import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5dbc7d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "detail-drawer-body"
}
const _hoisted_2 = { class: "detail-hero" }
const _hoisted_3 = { class: "detail-hero__main" }
const _hoisted_4 = { class: "detail-hero__content" }
const _hoisted_5 = { class: "detail-hero__title" }
const _hoisted_6 = { class: "detail-hero__tags" }
const _hoisted_7 = { class: "detail-hero__meta" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meta-sep" }, "|", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meta-sep" }, "|", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "meta-sep" }, "|", -1))
const _hoisted_11 = { class: "detail-hero__actions" }
const _hoisted_12 = { class: "info-attack-layout" }
const _hoisted_13 = { class: "info-attack-layout__left" }
const _hoisted_14 = { class: "info-attack-layout__title" }
const _hoisted_15 = { class: "info-list" }
const _hoisted_16 = { class: "info-list__label" }
const _hoisted_17 = { class: "info-list__value" }
const _hoisted_18 = { class: "info-list__label" }
const _hoisted_19 = { class: "info-list__value" }
const _hoisted_20 = { class: "info-list__label" }
const _hoisted_21 = { class: "info-list__value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-attack-layout__divider" }, null, -1))
const _hoisted_23 = { class: "info-attack-layout__right" }
const _hoisted_24 = { class: "info-attack-layout__title" }
const _hoisted_25 = { style: {"max-height":"300px","overflow-y":"auto"} }
const _hoisted_26 = {
  key: 1,
  class: ""
}

import { computed, ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import { formatTimeStamp } from '@/utils/time'
import { listCol } from '@/utils/list-columns-i18n'
import { SecurityDisposeStatus, SecurityEventLevel } from '../constants/enums'
import {
  listLevelColor,
  trHandleResultsSummary,
  trDisposeStatus,
  trListEventLevel,
  trEventTypeDisplay,
  trEventDesc,
  disposeStatusTagType
} from '../labels'
import { SecurityEventService } from '../security-event.service'
import type { SecurityEventDetail, SecurityEventListItem, ProcessChainNode } from '../types'
import type { SafeEventDetailApiResponse } from '../types/sdk-event-model'
import { mapProcessChainFromSdk } from '../security-event-detail.mapper'
import Card from '@/views/dashboard/_components/card/card.vue'
import RawDataDrawer from '@/views/dashboard/_components/raw-data-drawer/raw-data-drawer.vue'
import AttackStageDiagram from './attack-stage-diagram.vue'
import ProcessChainPanel from './process-chain-panel.vue'
import DisposeTimeline from './dispose-timeline.vue'
import CancelIgnoreDialog from './dialogs/cancel-ignore-dialog.vue'
import CancelTrustDialog from './dialogs/cancel-trust-dialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'security-event-detail',
  props: {
    modelValue: { type: Boolean },
    listRow: {}
  },
  emits: ["update:modelValue", "dispose", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const injector = useReflectiveInjector([SecurityEventService])
const securityEventService = injector.get(SecurityEventService)
const detail = ref<SecurityEventDetail | null>(null)
const processChainNodes = ref<ProcessChainNode[]>([])
const currentRawData = ref<SafeEventDetailApiResponse | SecurityEventDetail | SecurityEventListItem>({} as SecurityEventListItem)
const rawDataVisible = ref(false)
const cancelIgnoreVisible = ref(false)
const cancelTrustVisible = ref(false)
const threatFullscreen = ref(false)

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const levelCardClass = computed(() => {
  const lv = detail.value?.event_level
  if (lv === SecurityEventLevel.High) return 'level-high'
  if (lv === SecurityEventLevel.Medium) return 'level-medium'
  return 'level-low'
})

const disposeResultSummary = computed(() => {
  const d = detail.value
  if (!d) return t('securityEvent.disposeResultNone')
  const summary = trHandleResultsSummary(t, d.handle_result)
  return summary === '--' ? t('securityEvent.disposeResultNone') : summary
})

const disposeStatusTagTypeComputed = computed(() =>
  disposeStatusTagType(detail.value?.handle_status)
)

const showDispose = computed(
  () =>
    detail.value &&
    [SecurityDisposeStatus.Pending, SecurityDisposeStatus.Handled].includes(detail.value.handle_status)
)

async function loadDetail () {
  const businessId = props.listRow?.business_id
  if (!businessId) {
    detail.value = null
    processChainNodes.value = []
    return
  }
  try {
    detail.value =
      (await securityEventService.getDetail(businessId, props.listRow ?? undefined)) ?? null
    if (!detail.value) {
      ElMessage.error(t('common.failed'))
    }
    // 独立请求进程链数据
    const chainRes = await securityEventService.getSafeeventProcessChain({ business_id: businessId })
    processChainNodes.value = mapProcessChainFromSdk(
      undefined,
      [],
      undefined,
      chainRes.process_chain
    )
  } catch (e) {
    console.error(e)
    detail.value = null
    processChainNodes.value = []
    ElMessage.error(t('common.failed'))
  }
}

async function openRawData () {
  const businessId = props.listRow?.business_id || detail.value?.business_id
  if (!businessId) return
  try {
    const res = await securityEventService.getSafeEventDetail({ business_id: businessId })
    currentRawData.value = res ?? detail.value ?? props.listRow ?? {}
  } catch {
    currentRawData.value = detail.value ?? props.listRow ?? {}
  }
  rawDataVisible.value = true
}

async function confirmCancelIgnore () {
  if (!detail.value) return
  await securityEventService.cancelIgnore([detail.value])
  ElMessage.success(t('common.success'))
  await loadDetail()
  emit('refresh')
}

async function confirmCancelTrust () {
  if (!detail.value) return
  await securityEventService.cancelTrust([detail.value])
  ElMessage.success(t('common.success'))
  await loadDetail()
  emit('refresh')
}

function onCancelIgnore () {
  cancelIgnoreVisible.value = true
}

function onCancelTrust () {
  cancelTrustVisible.value = true
}

function toggleThreatFullscreen () {
  threatFullscreen.value = !threatFullscreen.value
  nextTick(() => {
    window.dispatchEvent(new Event('resize'))
  })
}

watch(
  () => [props.modelValue, props.listRow?.business_id] as const,
  ([open]) => {
    if (open) void loadDetail()
  }
)

watch(visible, (open) => {
  if (open) {
    void nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  } else {
    threatFullscreen.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      class: "security-event-detail-drawer",
      title: _ctx.$t('securityEvent.detailTitle'),
      size: "85%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (detail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Card, {
                size: "second",
                class: _normalizeClass(["detail-hero-card", levelCardClass.value])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["iconfont cm-icon-warning detail-hero__icon", levelCardClass.value])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(trEventDesc)(_unref(t), detail.value.event_id) || detail.value.event_desc || detail.value.threat_entity || '--'), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: _unref(listLevelColor)(detail.value.event_level),
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(trListEventLevel)(_unref(t), detail.value.event_level)), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_tag, {
                            size: "small",
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(trEventTypeDisplay)(_unref(t), detail.value)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: disposeStatusTagTypeComputed.value,
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(trDisposeStatus)(_unref(t), detail.value.handle_status)), 1)
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", null, _toDisplayString(_unref(listCol)(_unref(t), 'computerName')) + "：" + _toDisplayString(detail.value.computer_name), 1),
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('securityEvent.colGroup')) + "：" + _toDisplayString(detail.value.group_name || '--'), 1),
                          _hoisted_9,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('securityEvent.colUserName')) + "：" + _toDisplayString(detail.value.user_name || '--'), 1),
                          _hoisted_10,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('securityEvent.colIpAddress')) + "：" + _toDisplayString(detail.value.system_ip || detail.value.client_ip || '--'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: openRawData
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(listCol)(_unref(t), 'rawData')), 1)
                        ]),
                        _: 1
                      }),
                      (showDispose.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dispose', detail.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('securityEvent.actionQuickDispose')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (detail.value.handle_status === _unref(SecurityDisposeStatus).Ignored)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            size: "small",
                            onClick: onCancelIgnore
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('securityEvent.actionCancelIgnore')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (detail.value.handle_status === _unref(SecurityDisposeStatus).Trusted)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            size: "small",
                            onClick: onCancelTrust
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('securityEvent.actionCancelTrust')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(Card, {
                size: "second",
                class: "info-attack-card cm-ui-mt16 cm-ui-mb16"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t('securityEvent.sectionAlertInfo')), 1),
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", null, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('securityEvent.colAlertCount')), 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(detail.value.alarm_count) + _toDisplayString(_ctx.$t('securityEvent.alertCountUnit')), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('securityEvent.colFirstAlert')), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatTimeStamp)(detail.value.first_alarm_time)), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('securityEvent.colLastAlert')), 1),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatTimeStamp)(detail.value.last_alarm_time)), 1)
                        ])
                      ])
                    ]),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$t('securityEvent.sectionAttackMap')), 1),
                      _createVNode(AttackStageDiagram, {
                        "hit-stages": detail.value.hit_attack_stages || []
                      }, null, 8, ["hit-stages"])
                    ])
                  ])
                ]),
                _: 1
              }),
              (_openBlock(), _createBlock(_Teleport, {
                to: "body",
                disabled: !threatFullscreen.value
              }, [
                _createVNode(Card, {
                  size: "second",
                  class: _normalizeClass(["detail-threat-card cm-ui-mt16 cm-ui-mb16", { 'is-fullscreen': threatFullscreen.value }]),
                  title: _ctx.$t('securityEvent.sectionThreat')
                }, {
                  headerRight: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: _ctx.$t(threatFullscreen.value ? 'securityEvent.exitFullscreen' : 'securityEvent.enterFullscreen'),
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          circle: "",
                          size: "mini",
                          style: {"padding":"8px"},
                          "aria-label": _ctx.$t(threatFullscreen.value ? 'securityEvent.exitFullscreen' : 'securityEvent.enterFullscreen'),
                          onClick: toggleThreatFullscreen
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(threatFullscreen.value ? 'el-icon-close' : 'el-icon-full-screen'),
                              "aria-hidden": "true"
                            }, null, 2)
                          ]),
                          _: 1
                        }, 8, ["aria-label"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(ProcessChainPanel, {
                      nodes: processChainNodes.value,
                      "device-id": detail.value.device_id,
                      "hawk-md5": detail.value.file_md5,
                      "asset-ip": detail.value.system_ip || detail.value.client_ip,
                      computer_name: detail.value.computer_name,
                      fullscreen: threatFullscreen.value,
                      "event-type": _unref(trEventTypeDisplay)(_unref(t), detail.value),
                      "event-desc": detail.value.event_desc,
                      "hit-attack-stages": detail.value.hit_attack_stages,
                      "alarm-count": detail.value.alarm_count,
                      "first-alarm-time": detail.value.first_alarm_time,
                      "last-alarm-time": detail.value.last_alarm_time,
                      "event-level": detail.value.event_level,
                      "list-row-business-id": _ctx.listRow?.business_id
                    }, null, 8, ["nodes", "device-id", "hawk-md5", "asset-ip", "computer_name", "fullscreen", "event-type", "event-desc", "hit-attack-stages", "alarm-count", "first-alarm-time", "last-alarm-time", "event-level", "list-row-business-id"])
                  ]),
                  _: 1
                }, 8, ["class", "title"])
              ], 8, ["disabled"])),
              (detail.value.log.length)
                ? (_openBlock(), _createBlock(Card, {
                    key: 0,
                    size: "second",
                    title: _ctx.$t('securityEvent.sectionTimeline')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(DisposeTimeline, {
                          items: detail.value.log || []
                        }, null, 8, ["items"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]))
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, null, 512)), [
              [_directive_loading, !detail.value]
            ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(CancelIgnoreDialog, {
      modelValue: cancelIgnoreVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cancelIgnoreVisible).value = $event)),
      onConfirm: confirmCancelIgnore
    }, null, 8, ["modelValue"]),
    _createVNode(CancelTrustDialog, {
      modelValue: cancelTrustVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cancelTrustVisible).value = $event)),
      onConfirm: confirmCancelTrust
    }, null, 8, ["modelValue"]),
    _createVNode(RawDataDrawer, {
      modelValue: rawDataVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rawDataVisible).value = $event)),
      "raw-data": currentRawData.value
    }, null, 8, ["modelValue", "raw-data"])
  ], 64))
}
}

})